<header class="header">
    <img src="../../../../assets/images/logo.jfif" (load)="imageLoaded()" [class.d-none]="!imageWasLoaded" height="35" class="mt-1 mb-1 me-2" />
    <span class="header-title"></span>

    <ul class="menu">
        <li>
            <div [routerLink]="['/settings']">
                <div class="d-none d-lg-block align-items-center">
                    <i class="fa-solid fa-gear me-1"></i>
                    <span>{{ 'pressureMonitoring.actions.settings' | translation | async }}</span>
                </div>

                <div class="d-block d-lg-none d-xl-none" [ngbTooltip]="'pressureMonitoring.actions.settings' | translation | async">
                    <i class="fa-solid fa-gear"></i>
                </div>
            </div>
        </li>

        <li>
            <div (click)="changeLanguage()">
                <div class="d-none d-lg-flex align-items-center">
                    <i class="flag-icon me-1" [style.backgroundImage]="flagBackgroundImage()"></i>
                    <span>{{ 'defaults.lang' | translation | async }}</span>
                </div>

                <div class="d-block d-lg-none d-xl-none" [ngbTooltip]="'defaults.lang' | translation | async">
                    <i class="flag-icon" [style.backgroundImage]="flagBackgroundImage()"></i>
                </div>
            </div>
        </li>

        @if (!isUserLoggedIn()) {
            <li [ngbTooltip]="'actions.login' | translation | async">
                <a (click)="login()">
                    <i class="fas fa-sign-in-alt fa-lg me-1"></i>
                    <span>{{ 'actions.login' | translation | async }}</span>
                </a>
            </li>
        }
        @if (isUserLoggedIn()) {
            <li [ngbTooltip]="'actions.logout' | translation | async">
                <a (click)="logout()">
                    <div class="d-none d-lg-block">
                        <i class="fas fa-sign-out-alt fa-lg me-1"></i>
                        <span>{{ username() }}</span>
                    </div>
                    <div class="d-block d-lg-none d-xl-none">
                        <i class="fas fa-sign-out-alt fa-lg me-1"></i>
                    </div>
                </a>
            </li>
        }
    </ul>
</header>
